if (!customElements.get('variant-rows')) {
  class VariantRows extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
    }

    connectedCallback() {
      this.rows = this.querySelectorAll('.ai-variant-row');
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.rows.forEach(row => {
        row.addEventListener('click', this.handleRowClick.bind(this));
        row.addEventListener('keydown', this.handleRowKeydown.bind(this));
      });
    }

    handleRowClick(event) {
      const row = event.currentTarget;
      if (row.dataset.available === 'false') return;

      this.selectRow(row);
    }

    handleRowKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.handleRowClick(event);
      }
    }

    selectRow(selectedRow) {
      this.rows.forEach(row => row.classList.remove('selected'));
      selectedRow.classList.add('selected');

      const variantId = selectedRow.dataset.variantId;

      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);

      this.updateProductForm(variantId);
      this.updateProductInfo(selectedRow);

      this.dispatchEvent(new CustomEvent('variant-change', {
        detail: {
          variantId: variantId,
          variant: {
            id: variantId,
            price: selectedRow.dataset.price,
            compare_at_price: selectedRow.dataset.comparePrice,
            available: selectedRow.dataset.available === 'true'
          }
        },
        bubbles: true
      }));
    }

    updateProductForm(variantId) {
      const productForms = document.querySelectorAll('form[action*="/cart/add"]');
      productForms.forEach(form => {
        const variantInput = form.querySelector('input[name="id"], select[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
        }
      });
    }

    updateProductInfo(selectedRow) {
      const price = selectedRow.dataset.price;
      const comparePrice = selectedRow.dataset.comparePrice;

      const priceElements = document.querySelectorAll('.price');
      priceElements.forEach(element => {
        if (element.querySelector('.price__regular')) {
          const regularPrice = element.querySelector('.price__regular .price-item--regular');
          const salePrice = element.querySelector('.price__sale .price-item--sale');

          if (comparePrice && comparePrice > price) {
            if (regularPrice) regularPrice.textContent = Shopify.formatMoney(comparePrice);
            if (salePrice) salePrice.textContent = Shopify.formatMoney(price);
            element.classList.add('price--on-sale');
          } else {
            if (regularPrice) regularPrice.textContent = Shopify.formatMoney(price);
            element.classList.remove('price--on-sale');
          }
        }
      });
    }
  }

  customElements.define('variant-rows', VariantRows);
}
